export const actionsNames = {
  cancelOrder: 'cancelOrder',
  addToBasket: 'addToBasket',
  increaseBasketQuantity: 'increaseBasketQuantity',
  decreaseBasketQuantity: 'decreaseBasketQuantity',
  addAnotherToBasket: 'addAnotherToBasket',
  removeFromBasket: 'removeFromBasket',
  hardLimitOrder: 'HardLimitOrder',
  addToMeal: 'addToMeal',
  increaseQuantityInMeal: 'increaseQuantityInMeal',
  decreaseQuantityInMeal: 'decreaseQuantityInMeal',
  removeFromMeal: 'removeFromMeal',
  orderPlaced: 'orderPlaced',
  meal2Partial: 'meal2Partial',
  recommendationAdd: 'recommendationAdd',
  recommendedItems: 'recommendedItems',
  discountCodeApplied: 'discountCodeApplied',
  discountSmsRequested: 'discountSmsRequested',
  activationCodeEntered: 'activationCodeEntered',
  kiosk: {
    receiptRequested: 'receiptRequested',
  },
  preorder: {
    userRegistered: 'userRegistered',
    userLoggedIn: 'userLoggedIn',
    cardAdded: 'cardAdded',
    userLoggedOut: 'userLoggedOut',
    payment: 'preorderPayment',
  },
  storeLandingPage: 'storeLandingPage',
  orderConfirmation: 'orderConfirmation',
  orderConfirmationPage: 'orderConfirmationPage',
  promoView: 'promoView',
  promoClick: 'promoClick',
  viewReorderModal: 'viewReorderModal',
  reorderFeature: 'reorderFeature',
  rewardsNavbarClicked: 'rewardsNavbarClicked',
  userHasRewards: 'userHasRewards',
  changeStoreButtonClicked: 'changeStoreButtonClicked',
  openMenu: 'openMenu',
  locationLoadedSuccess: 'locationLoadedSuccess',
  timeSlotsLoaded: 'timeSlotsLoaded',
  forgotPassword: 'forgotPassword',
  sendPasswordResetLink: 'sendPasswordResetLink',
};

export const screenNames = {
  home: 'home',
  menuCategory: 'menuCategory',
  basket: 'basket',
  mealCategory: 'mealCategory',
  mealReview: 'mealReview',
  kiosk: {
    kioskCheckoutPointsShop: 'kioskCheckoutPointsShop',
    config: 'config',
    payment: 'payment',
    splash: 'splash',
  },
  preorder: {
    storeSelection: 'storeSelection',
    pickupTime: 'pickupTime',
    manageCards: 'manageCards',
    login: 'login',
    register: 'register',
    orderHistory: 'orderHistory',
    profilePointsShop: 'profilePointsShop',
    accountSettings: 'accountSettings',
    introduction: 'introduction',
    subscriptions: 'subscriptions',
    welcome: 'welcome',
  },
  meal2Mainpage: 'meal2Mainpage',
  meal2Subpage: 'meal2Subpage',
};
